import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserLoginService, LoggedInCallback } from "../services/cognito/cognito.service";
import { CognitoTokensService } from '../services/cognito/cognito-tokens.service';

@Injectable()
export class GuestAuthenticationService implements LoggedInCallback {
  userLoggedIn = false;
 
  constructor(private router: Router, 
              private userLoginService: UserLoginService,
              private cognitoTokenService: CognitoTokensService){
  }
 
  logout() {        
    localStorage.removeItem("user");
    localStorage.removeItem("username");
    localStorage.removeItem("talentPageIndex");
    localStorage.clear();
    this.router.navigate(['pages/login']);
  }

  checkCredentials() {
    if (localStorage.getItem("user") === null){
        this.router.navigate(['pages/login']);
    }
  } 
    isAuthenticated(){
    if(localStorage.getItem("userRole") && 
      ((localStorage.getItem("userRole") == "client")) || 
      (localStorage.getItem("userRole") == "recruiter") || 
      (localStorage.getItem("userRole") == "admin")) {
      this.userLoggedIn = this.cognitoTokenService.checkTokenExpiry();
    } else {
      this.userLoggedIn = false;
    }
    const promise = new Promise(
      (resolve, reject) =>{
        setTimeout(() => {          
          resolve(this.userLoggedIn)
        } ,800);
      });
    return promise;
  }

  isLoggedIn(message: string, isLoggedIn: boolean) {
      if (isLoggedIn) {
        this.userLoginService.logout();       
      }
  }
  
}


// WEBPACK FOOTER //
// ./src/app/services/guest-authentication.service.ts